module.exports = __webpack_public_path__ + "static/media/Hun Warrior.54ba9d53.jpg";